import { CallSection } from "@/components/CallSection/CallSection";
import { Debug } from "@/components/Debug/Debug";
import { EvaluationEdit } from "@/components/EvaluationEdit/EvaluationEdit";
import { EvaluationEmptyView } from "@/components/EvaluationEmptyView/EvaluationEmptyView";
import { EvaluationNew } from "@/components/EvaluationNew/EvaluationNew";
import { EvaluationResult } from "@/components/EvaluationResult/EvaluationResult";
import { Health } from "@/components/Health/Health";
import { NotFoundErrorScreen } from "@/components/NotFoundErrorScreen/NotFoundErrorScreen";
import { SectionCallContext } from "@/components/SectionCallContext/SectionCallContext";
import { SectionEvaluationRedirect } from "@/components/SectionEvaluationRedirect/SectionEvaluationRedirect";
import { SectionNotes } from "@/components/SectionNotes/SectionNotes";
import { useInits } from "@/hooks/useInits/useInits";
import { RESOURCE, RouteAccess } from "@dashboard/library";

import { Route, Routes } from "react-router-dom";
import { Assets } from "./Assets";

import { RequireAgentLicense } from "@/components/RequireAgentLicense/RequireAgentLicense";

import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";
import { isDev } from "@/helpers/environment/environment.helpers";
import { DevHome } from "@/playground/components/DevHome/DevHome";
import { Playground } from "@/playground/components/Playground";

export function AppRoutes() {
  const hasEvaluationTabAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.EVALUATION_TAB_ACCESS,
  });

  useInits();

  return (
    <Routes>
      {isDev() && <Route path="/" element={<DevHome />} />}
      {isDev() && <Route path="/playground" element={<Playground />} />}
      <Route path="/debug" element={<Debug />} />
      <Route path="/health" element={<Health />} />
      <Route
        path="/calls/:callId/:callType/*"
        element={<RouteAccess resource={[RESOURCE.ASSET]} />}
      >
        <Route path="" element={<Assets />}>
          <Route path="notes" element={<SectionNotes />} />
          <Route path="info" element={<CallSection />} />
          <Route path="insights" element={<SectionCallContext />} />
          {hasEvaluationTabAccess && (
            <Route path="evaluation" element={<RequireAgentLicense />}>
              <Route path="result" element={<EvaluationResult />} />
              <Route path="new" element={<EvaluationNew />} />
              <Route path="edit" element={<EvaluationEdit />} />
              <Route path="empty" element={<EvaluationEmptyView />} />
              <Route path="" element={<SectionEvaluationRedirect />} />
              <Route path="*" element={<SectionEvaluationRedirect />} />
            </Route>
          )}
        </Route>
      </Route>
      <Route path="*" element={<NotFoundErrorScreen />} />
    </Routes>
  );
}
